module.exports = __webpack_public_path__ + "img/info-dark.a2159d17.svg";